import { Link } from 'wouter';
import { ROUTES } from '../../routes/consts';

export const ProUserProfileLink = ({
  userId,
  name,
}: {
  userId?: number | null;
  name?: string | null;
}) => {
  if (userId && name) {
    return (
      <Link
        to={`~/platform${ROUTES.DIRECTORY}/professionals/${userId}`}
        className='text-brand-100 hover:underline'
      >
        {name}
      </Link>
    );
  }
};

export const OrganizationProfileLink = ({
  organizationId,
  organizationName,
}: {
  organizationId?: number | null;
  organizationName?: string | null;
}) => {
  if (organizationId && organizationName) {
    return (
      <Link
        to={`~/platform${ROUTES.DIRECTORY}/organizations/${organizationId}`}
        className='text-brand-500 hover:underline'
      >
        {organizationName}
      </Link>
    );
  }
  return <span>{organizationName}</span>;
};

export const ProjectLink = ({
  projectId,
  projectName,
}: {
  projectId?: number | null;
  projectName?: string | null;
}) => {
  if (projectId && projectName) {
    return (
      <Link
        to={`~/platform${ROUTES.DIRECTORY}/projects/${projectId}`}
        className='text-brand-500 hover:underline'
      >
        {projectName}
      </Link>
    );
  }
};
